import { auth } from "../firebase";

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8080";

async function getHeaders() {
  const user = auth.currentUser;

  if (!user) {
    return null;
  }

  const token = await user.getIdToken();

  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}

async function api(path, options = {}) {
  const headers = await getHeaders();

  if (!headers) {
    return { ok: false, unauthenticated: true };
  }

  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      ...headers,
      ...(options.headers || {}),
    },
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    throw new Error(data?.error || "Request failed");
  }

  return data;
}

export async function apiGetFavorites() {
  return api("/api/favorites", { method: "GET" });
}

export async function apiAddFavorite(product) {
  const id = String(product?.product_id || product?.variant_id || product?.id || "");

  return api("/api/favorites", {
    method: "POST",
    body: JSON.stringify({
      product_id: id,
    }),
  });
}

export async function apiRemoveFavorite(product) {
  const id = String(product?.product_id || product?.variant_id || product?.id || "");

  return api(`/api/favorites/${encodeURIComponent(id)}`, {
    method: "DELETE",
  });
}